class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/ServiceProviderConfig`;
    }
    /**
     * Returns SCIM service provider configuration
     * HTTP Method: get
     * Endpoint: /scim/{version}/ServiceProviderConfig
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
